





















import { Component, Vue, Prop } from 'nuxt-property-decorator'
import { IStyle } from '~/assets/interfaces/classes'
import { ICatalogLabel } from '~/assets/interfaces/catalog'
import { isAbsoluteUrl } from '~/assets/functions/url'

@Component
export default class ComponentCatalogLabels extends Vue {
  @Prop({ type: Array, default: () => [] }) private items!: ICatalogLabel[]
  @Prop({ type: Boolean, default: false }) private small!: boolean

  private $style!: IStyle

  private classItem(item: ICatalogLabel) {
    let temp = { [this.$style.item]: true }
    temp = Object.assign(temp, {
      [this.$style.error]: item.color === 'error',
      [this.$style.secondary]: item.color === 'secondary',
      [this.$style.success]: item.color === 'success',
      [this.$style.gray]: item.color === 'gray',
      [this.$style.primary]: item.color === 'primary',
      [this.$style.small]: this.small,
    })
    return temp
  }

  private styleItem(item: ICatalogLabel) {
    if (/^#([0-9A-F]{3}){1,2}$/i.test(item.color)) {
      return {
        background: item.color,
      }
    }
    return {}
  }

  private componentItem(item: ICatalogLabel) {
    if (item.url) {
      if (isAbsoluteUrl.test(item.url)) {
        return 'a'
      } else {
        return 'nuxt-link'
      }
    }
    return 'div'
  }

  private mounted() {
    this.$emit('loaded')
  }
}
